import { Component, Input, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as ModuleStructure from 'src/app/models/module-structure';
import { RecordListDrawerArgs } from '@app/models/record-list-drawer-args';
import { RecordsListComponent } from '@app/layout/records-list/records-list.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { RecordPageComponent } from '@app/layout/record-page/record-page.component';
import { ActivatedRoute } from '@angular/router';
import { ModuleInformation } from '@app/models/module-information';
import * as g from '../../../globals';

@Component({
  selector: 'app-input-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.less'],
})
export class TextComponent extends Field {
  term = '';
  loadingDropDownMenu: boolean;
  moduleInformation: ModuleInformation;
  validateClicked = false;

  searchDrawerVisible = false;
  options: { value: string | number; label: string }[] = [];

  showChildDrawer = false;
  childDrawerData: any[];
  childDrawerDataHead: string[];

  itemField: ModuleStructure.Field;

  line: any;

  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService);
  }

  ngOnInit(): void {
    this.layoutService
      .getFieldDetails(100018)
      .subscribe((f: ModuleStructure.Field) => {
        this.itemField = f;
      });
    if (this.actionType === 'View') {
      let fieldsTobeEditableOnClose: string[] = [];
      let sectionTobeEditableOnClose: string[] = [];
      const parsed = g.parseCustomConfiguration(g.allowEditEvenWhenClose);
      const parsedSection = g.parseCustomConfiguration(
        g.allowAddLinesEvenWhenClose
      );

      if (
        parsed.hasOwnProperty(this.recordModel.ObjectKey) &&
        Array.isArray(parsed[this.recordModel.ObjectKey]) &&
        parsed[this.recordModel.ObjectKey].length > 0
      ) {
        fieldsTobeEditableOnClose = parsed[this.recordModel.ObjectKey];
      }

      if (
        parsedSection.hasOwnProperty(this.recordModel.ObjectKey) &&
        Array.isArray(parsedSection[this.recordModel.ObjectKey]) &&
        parsedSection[this.recordModel.ObjectKey].length > 0
      ) {
        sectionTobeEditableOnClose = parsedSection[this.recordModel.ObjectKey];
      }

      let sectionIsEditable =
        sectionTobeEditableOnClose.findIndex(
          (x) => x === this.sectionTagName
        ) !== -1;

      let fieldIsNotEditable =
        fieldsTobeEditableOnClose.findIndex(
          (x) => x === this.field.PropertyName
        ) === -1;

      if (!sectionIsEditable) {
        if (fieldIsNotEditable) {
          this.recordProperty.ReadOnly = true;
        }
      }
    }
  }

  applyChanges() {
    if (this.childDrawerData.length == 0) {
      this.recordProperty.ValueAsObject = '';
    } else {
      this.recordProperty.ValueAsObject = JSON.stringify(this.childDrawerData);
    }
    this.showChildDrawer = false;
  }

  deleteRow(index) {
    this.childDrawerData.splice(index, 1);
    this.childDrawerData = [...this.childDrawerData];
  }

  openChildDrawer() {
    this.showChildDrawer = true;
    this.childDrawerData = JSON.parse(this.recordProperty.ValueAsObject);
    if (this.childDrawerData.length !== 0) {
      this.childDrawerDataHead = Object.keys(this.childDrawerData[0]);
      this.childDrawerData.forEach((element) => {
        if (
          element['Max'] == null ||
          element['Max'] === undefined ||
          element['Max'] === '' ||
          element['Max'] === '0'
        ) {
          element['Max'] = element['Qty'];
        }
      });
    }
  }

  onType(e: Event): void {
    const value = (e.target as HTMLInputElement).value;
    this.onTypeData(4, value);
  }

  onTypeData(linkedField, value) {
    const body = {
      moduleId: linkedField,
      term: value,
      linkedFieldId: 100018,
      valuesToPass: ModuleStructure.Field.getValuesToPassBasedOnConditions(
        this.itemField,
        this.recordModel,
        this.lineId,
        this.sectionTagName
      ),
    };

    this.layoutService
      .getAutoCompleteType(body)
      .subscribe(
        (d: {
          Count: number;
          Rows: { value: string | number; label: string }[];
        }) => {
          this.options = d.Rows;
        }
      );
  }

  validateSelection(value: string, template: any) {
    this.validateClicked = true;
    this.validationSelectionData(4, value, template);
  }

  validationSelectionData(linkedField, value, template: any) {
    this.line = template;
    const body = {
      moduleId: linkedField,
      term: value,
      linkedFieldId: 100018,
      valuesToPass: ModuleStructure.Field.getValuesToPassBasedOnConditions(
        this.itemField,
        this.recordModel,
        this.lineId,
        this.sectionTagName
      ),
    };

    this.layoutService
      .getAutoCompleteValidate(body)
      .subscribe((d: { OneResult: boolean; Value: string }) => {
        if (d.OneResult) {
          //this.selectedRecords = [d.Value];
          this.submitSelection(d.Value);
        } else {
          this.term = value;
          this.openSearchDrawer(template);
        }
      });
  }

  submitSelection(fromTyping: any) {
    this.submitSelectionData(4, fromTyping);
  }

  submitSelectionData(linkedModule, fromTyping: any) {
    this.line['Artikle Nr.'] = fromTyping;

    this.layoutService
      .getModuleHeaderData('4', fromTyping, 'ItemCode', false)
      .subscribe((d) => {
        console.log(d);
        this.line['Artikelbeschreibung'] = d['ItemName'];
        this.line = {};
      });
  }

  async openSearchDrawer(template: any) {
    this.searchDrawerVisible = true;
    this.executeOpenSearchDrawer(4, template);
  }

  executeOpenSearchDrawer(linkedModule, template: any) {
    const args: RecordListDrawerArgs = {
      parentComponent: this,
      moduleId: Number(linkedModule),
      inDrawer: true,
      isSingleSelection:
        this.itemField.PropertyName === 'ItemCode' && this.section.Type === 2
          ? false
          : true,
      linkedFieldId: 100018,
      linkedFieldSectionTagName: this.sectionTagName,
      term: this.term,
      lineId: this.lineId,
      recordModel: this.recordModel,
      showCheckBoxInTableMode: true,
    };

    RecordsListComponent.openRecordListDrawer(this.drawerService, args);

    this.line = template;
  }

  openView(itemCode: string) {
    console.log('xxx');
    if (itemCode === '') {
      return;
    }
    let recordEntry = itemCode;
    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: 'View',
      drawerTitle: 'View Details',
      inDrawer: true,
      moduleId: Number(4),
      parentComponent: this,
      recordId: recordEntry,
      recordModel: undefined,
    });
  }

  triggerMenu(newValue) {
    if (newValue) {
      this.loadingDropDownMenu = true;
      const moduleId = '4';
      this.layoutService
        .moduleInformation(moduleId)
        .subscribe((d: ModuleInformation) => {
          this.moduleInformation = d;
          this.loadingDropDownMenu = false;
        });
    }
  }
}
